import React, {useState,useRef} from 'react'
import EmailEditor from './EmailEditor'
import { Button } from 'react-bootstrap'
function EmailEditorTest() {
 const saveEmailRef = useRef(null)

  const handleSave = async () => {
    if (saveEmailRef.current && typeof saveEmailRef.current === 'function') {
      try {
        const result = await saveEmailRef.current()
        console.log('Saved:', result)
        //save the data in templates folder 
        const jsonData = JSON.stringify(result, null, 2)
        const blob = new Blob([jsonData], { type: 'application/json' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'template.json'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
        console.log('Saved:', result)

        // Handle the saved data
      } catch (error) {
        console.error('Save failed:', error)
      }
    } else {
      console.error('Save function not available yet')
    }
  }

  return (
    <>
       <Button onClick={handleSave}>Save</Button>
      
        <EmailEditor 
            saveemail={(saveFunc) => {
             saveEmailRef.current = saveFunc
             }}/>
    </>
  )
}


export default EmailEditorTest